/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SelectionTagSelectionValueTreeList } from '../../models/selection-tag-selection-value-tree-list';
import { StampRowType } from '../../models/stamp-row-type';

export interface StampGetStampTagSelectionValueTreeList$Params {

/**
 * GUID of the document
 */
  documentId?: string;

/**
 * GUID of the stamp
 */
  stampId?: string;

/**
 * GUID of the tag definition
 */
  tagDefinitionId?: string;

/**
 * GUID of the stamp row
 */
  stampRowId?: string;

/**
 * Stamp row type
 */
  stampRowType?: StampRowType;
}

export function stampGetStampTagSelectionValueTreeList(http: HttpClient, rootUrl: string, params?: StampGetStampTagSelectionValueTreeList$Params, context?: HttpContext): Observable<StrictHttpResponse<SelectionTagSelectionValueTreeList>> {
  const rb = new RequestBuilder(rootUrl, stampGetStampTagSelectionValueTreeList.PATH, 'get');
  if (params) {
    rb.query('documentId', params.documentId, {});
    rb.query('stampId', params.stampId, {});
    rb.query('tagDefinitionId', params.tagDefinitionId, {});
    rb.query('stampRowId', params.stampRowId, {});
    rb.query('stampRowType', params.stampRowType, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SelectionTagSelectionValueTreeList>;
    })
  );
}

stampGetStampTagSelectionValueTreeList.PATH = '/stamp/tag/selection-value/tree-list';
